import { getIsClassicOutlookStyleEnabledForTheme } from "owa-theme-common/lib/selectors/isUserPersonalizationAllowed";
import { shouldUseCobranding } from "owa-theme-common/lib/selectors/shouldUseCobranding";
import { ThemeConstants } from "owa-theme-shared";
import { getIsDarkThemeFromParameter, getThemeIdFromParameter, } from "../utils/optionalArgumentHelpers";

/**
 * Checks for classic Outlook's light-blue theme in light mode: Office blue or unbranded base.
 * Omitted arguments use the current theme and dark-mode settings.
 */
export function getIsWin32ColorfulLightTheme(themeId?: string, isDarkTheme?: boolean): boolean {
    const theme = getThemeIdFromParameter(themeId);
    return (getIsClassicOutlookStyleEnabledForTheme() &&
        !getIsDarkThemeFromParameter(isDarkTheme) &&
        (theme === ThemeConstants.BASE_OFFICE_THEME_ID ||
            (theme === ThemeConstants.BASE_THEME_ID && !shouldUseCobranding(theme))));
}
